import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@upme/ui/components/alert-dialog';
import { Avatar, AvatarFallback, AvatarImage } from '@upme/ui/components/avatar';
import { Button } from '@upme/ui/components/button';
import { useRef } from 'react';
import { toast } from 'sonner';
import { useDeleteFakePhoto, useUploadFakePhoto } from '../mutations';

interface Props {
  userId: string;
  photoUrl: string | null;
}

export function FakePhotoUploader({ userId, photoUrl }: Props) {
  const upload = useUploadFakePhoto(userId);
  const del = useDeleteFakePhoto(userId);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="flex items-center gap-4">
      <Avatar className="size-24">
        {photoUrl ? <AvatarImage src={photoUrl} /> : null}
        <AvatarFallback>?</AvatarFallback>
      </Avatar>
      <div className="flex gap-2">
        <input
          ref={inputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp"
          className="hidden"
          onChange={async (e) => {
            const f = e.target.files?.[0];
            if (!f) return;
            try {
              await upload.mutateAsync(f);
              toast.success('Фото обновлено');
            } catch (err) {
              toast.error((err as Error).message);
            } finally {
              if (inputRef.current) inputRef.current.value = '';
            }
          }}
        />
        <Button variant="outline" onClick={() => inputRef.current?.click()}>
          {photoUrl ? 'Заменить' : 'Загрузить'}
        </Button>
        {photoUrl ? (
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button variant="destructive">Удалить</Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>Удалить аватар?</AlertDialogTitle>
                <AlertDialogDescription>Действие необратимо.</AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>Отмена</AlertDialogCancel>
                <AlertDialogAction
                  onClick={async () => {
                    try {
                      await del.mutateAsync();
                      toast.success('Аватар удалён');
                    } catch (err) {
                      toast.error((err as Error).message);
                    }
                  }}
                >
                  Удалить
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        ) : null}
      </div>
    </div>
  );
}
